import axios from "./index";

export default {
  getAll() {
    return axios.get("/v1/setting/tags");
  },
  getDropdown() {
    return axios.get("/v1/setting/tags/dropdown");
  },
  create(data) {
    return axios.post("/v1/setting/tags", data);
  },
  update(data) {
    return axios.patch("/v1/setting/tags", data);
  },
};
